import { render, staticRenderFns } from "./SelfProfile.vue?vue&type=template&id=9a882372&scoped=true&"
import script from "./SelfProfile.vue?vue&type=script&lang=js&"
export * from "./SelfProfile.vue?vue&type=script&lang=js&"
import style0 from "./SelfProfile.vue?vue&type=style&index=0&id=9a882372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a882372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
